import { t } from '../../../lib/i18n';
import { type User } from '../types';
import { formatShortDate } from '../utils';

/**
 * «Дані» tab — the six identity fields the artboard lists, read-only.
 *
 * The artboard draws a «Редагувати» button beside the heading. It is not
 * implemented: this API exposes no admin edit for another user's identity
 * fields beyond `verified` and `verificationLevel`, and a button that opens
 * nothing is worse than no button. Reported rather than faked.
 */
export function UserInfoTab({ user }: { user: User }) {
  const fields: { label: string; value: string }[] = [
    { label: t('clients.detail.personal.firstName'), value: user.firstName || '—' },
    { label: t('clients.detail.personal.lastName'), value: user.lastName || '—' },
    { label: t('clients.detail.personal.displayName'), value: user.displayName || '—' },
    { label: t('clients.detail.personal.email'), value: user.email || '—' },
    {
      label: t('clients.detail.personal.birthDate'),
      value: user.dateOfBirth ? formatShortDate(user.dateOfBirth) : '—',
    },
    { label: t('clients.detail.personal.phone'), value: user.phone || '—' },
  ];

  return (
    <section className="rounded-cf-lg border border-cf-line bg-cf-surface px-4 py-1 lg:px-6 lg:py-[22px]">
      <h2 className="hidden text-[18px] font-semibold tracking-[-0.02em] lg:block">
        {t('clients.detail.personal.title')}
      </h2>

      <div className="lg:mt-2.5 lg:grid lg:grid-cols-3 lg:gap-x-8">
        {fields.map((field) => (
          <div key={field.label} className="border-b border-cf-line-soft py-2.5 lg:py-3">
            <div className="text-xs text-cf-ink-subtle">{field.label}</div>
            <div
              className={`mt-0.5 text-[15px] lg:mt-[3px] ${
                field.value === '—' ? 'text-cf-ink-subtle' : 'text-cf-ink'
              }`}
            >
              {field.value}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
